/**
 * @fileoverview This file contains the code that handles the new KS bundle
 * system, enables to add bundle items to the cart individually which replaces
 * the old mbcBundle system.
 */

/**
 * ----------------------------------------------------------------------------
 * Collection product item
 * ----------------------------------------------------------------------------
 */
$(document).ready(function () {
  $(document).on('click', '.ProductBundles', function (e) {
    // Prevent cart from opening for sold out bundles.
    if ($(this).html === 'Sold Out') {
      e.preventDefault();
      return;
    }

    let includedBundleProductSkus = {};
    let productId = $(this).attr('product-id');
    let productHandle = $(this).attr('product-handle');

    const KS_BUNDLES = JSON.parse(
      atob(window.localStorage.getItem('ks_bundles'))
    );
    const BUNDLE = KS_BUNDLES[productHandle];

    // Product quantity is determined by the value of input in the add to cart
    // button.
    let productQuantity =
      $(this).prev().val() ||
      $(
        '.ProductForm__QuantitySelector > .QuantitySelector >' +
          '.QuantitySelector__CurrentQuantity'
      ).val();

    /*
     * Handles error cases when bundle is not set on the theme customizer.
     * Enables product to be added to cart without having to set the bundle in
     * the customizer. Act as if it was a normal product.
     */
    if (BUNDLE === undefined) {
      addToCartAjax(
        [
          {
            id: productId,
            quantity: productQuantity,
            properties: {},
          },
        ],
        this
      );
      return;
    }

    // Disables customers to add the bundle if its not available.
    if (!BUNDLE.available) return;
    let bundleItems = BUNDLE.items;

    getIncludedItemSkus(bundleItems, includedBundleProductSkus);

    // Check for products that have the same name but different product types.
    if (bundleItems.length !== Object.keys(includedBundleProductSkus).length) {
      includedBundleProductSkus = {};
      getIncludedItemSkus(bundleItems, includedBundleProductSkus, true);
    }

    // N.B. For the old 'mbcBundles,' we were discounting the actual product
    // referencer itself, now that we are switching to adding items individually
    // to the cart, we are now discounting individual items that are included
    // in the bundle instead of the referencer.
    let bundleId = bundleIdBuilder(bundleItems.map((item) => item.sku));

    // Check for items that are part of the bundle.
    let bundleLineItems = [];
    bundleItems.forEach((item) => {
      bundleLineItems.push({
        id: item.id,
        quantity: productQuantity,
        properties: {
          _bundle_id: bundleId,
          _bundle_discount: Number(BUNDLE.discount),
          _bundle_alias: BUNDLE.discount_name,
          _bundle_ref_handle: productHandle,
        },
      });
    });

    // Include discount name to be displayed at checkout.
    includedBundleProductSkus['_discount_name'] = BUNDLE.discount_name;

    // If there are items in the bundle, add the bundle reference to the
    // product. Sometimes, products that are considered 'bundles' do not
    // contain any additional items mapped to them. Meaning the bundle
    // reference's price is not set to 0. So we would need to discount the
    // product itself instead of the individual items.
    if (bundleLineItems.length !== 0) {
      includedBundleProductSkus['_bundle_reference'] = bundleId;
    }

    // If there are no items in the bundle, add the bundle discount to the
    // bundle reference itself, for it to be discounted.
    if (bundleLineItems.length === 0) {
      includedBundleProductSkus['_bundle_discount'] = Number(BUNDLE.discount);
    }

    // Add the bundle reference to the cart.
    bundleLineItems.push({
      id: productId,
      quantity: productQuantity,
      properties: includedBundleProductSkus,
    });
    addToCartAjax(bundleLineItems, this);
  });

  productAvailabilityChecker();
});

/**
 * Gets all included items of the bundle and store it on an object. This
 * includes the name, sku, and maybe the type of the product if there are
 * product names that have the same name but different product types.
 * @param {Array.<Object.<string><string><string><boolean>>} bundleItems - 2d
 *   array that contains the name, producttype, sku, and availability of the
 *   included items.
 * @param {Object} includedBundleProductSkus - Stores the product names and skus
 *   that is part of the bundle.
 * @param {boolean} includeProductType - Determines if the product type should
 *   be included in the product name.
 */
function getIncludedItemSkus(
  bundleItems,
  includedBundleProductSkus,
  includeProductType = false
) {
  for (let includedProduct of bundleItems) {
    let productSku = includedProduct.sku;
    if (productSku === '') {
      productSku = 'NOSKU';
    }
    if (includeProductType) {
      includedBundleProductSkus[
        `- ${includedProduct.title} (${includedProduct.type})`
      ] = productSku;
    } else {
      includedBundleProductSkus[`- ${includedProduct.title}`] = productSku;
    }
  }
}

/**
 * Checks if bundle is available for displaying it as a collection item or
 * in product pages. Collections items are usually displayed as a grid in
 * landing pages, collection pages, and product recommendations.
 */
function productAvailabilityChecker() {
  const KS_BUNDLES = JSON.parse(
    atob(window.localStorage.getItem('ks_bundles'))
  );
  $('.ProductBundles').each(async function () {
    let bundleHandle = $(this).attr('product-handle');
    let innerHTML = $(this).text().trim();
    if (innerHTML === 'Loading...') {
      let addToCart = document.createElement('span');

      /**
       * Marks the buttons with a sold out text. Allowing users to know that
       * the bundle is not available.
       */
      let soldOut = () => {
        $(this).addClass('Button--secondary');
        $(this).removeClass('Button--primary');
        $(this).attr('disabled', 'disabled');
        addToCart.innerText = 'Sold Out';
        $(this).html(addToCart);
      };

      /**
       * Marks the buttons with an add to cart text. Allowing users to add the
       * bundle to their cart.
       */
      let available = () => {
        addToCart.innerText = 'Add To Cart';
        $(this).removeAttr('disabled');
        $(this).html(addToCart);
      };

      // Check for items that has a product type of KS bundle or mbcBundle
      // but not set in the customizer for bundle settings. And also check for
      // bundles that have no items in it. If either of these two conditions are
      // met, product availability will be checked from the product itself,
      // instead of having to check the items included in the bundle for
      // product availability.
      if (
        KS_BUNDLES[bundleHandle] === undefined ||
        KS_BUNDLES[bundleHandle].items.length === 0
      ) {
        if ($(this).attr('product-available') === 'true') {
          available();
        } else {
          soldOut();
        }
      } else if (KS_BUNDLES[bundleHandle]['available']) {
        available();
      } else {
        soldOut();
      }
    }
  });

  // Display bundle pricing on collection items.
  $('.ProductItem__PriceList').each(function (idx, domElement) {
    displayBundlePricing(this, KS_BUNDLES);
  });

  // Display bundle pricing on the product page.
  if ($('.ProductMeta__PriceList').length) {
    displayBundlePricing($('.ProductMeta__PriceList')[0], KS_BUNDLES);
  }
}

/**
 * Displays the bundle pricing on the collection items or product page.
 * @param {HTMLelement} element - Container element of the pricing and sku.
 * @param {Object} ksBundles - Bundles that were set in the customizer.
 */
function displayBundlePricing(element, ksBundles) {
  // Determines if the product is a bundle or not. Bundle items have an
  // attribute of product-handle.
  let bundleHandle = $(element).attr('product-handle');
  let bundlePrice = $(element).attr('product-price');
  let innerHTML = $(element).text().trim();

  if (bundleHandle !== undefined && innerHTML === 'Loading...') {
    const PRODUCT_PRICE = document.createElement('span');
    PRODUCT_PRICE.classList.add(
      'ProductMeta__Price',
      'Price',
      'Text--subdued',
      'u-h4'
    );
    PRODUCT_PRICE.style.fontSize = '12px';
    PRODUCT_PRICE.dataset.moneyConvertible = '';
    let saleSettings = getSiteSettings().sale_settings;

    // Do not discount bundles which are not set in the customizer unless there
    // is a sitewide sale going on.
    if (
      ksBundles[bundleHandle] === undefined &&
      !saleSettings.sitewide.active
    ) {
      PRODUCT_PRICE.innerText = bundlePrice;
      $(element).html(PRODUCT_PRICE);
    } else {
      const FINAL_PRICE = PRODUCT_PRICE.cloneNode(false);
      const ORIGINAL_PRICE = PRODUCT_PRICE.cloneNode(false);
      FINAL_PRICE.classList.add('Price--highlight');
      let newPrice = ksBundles[bundleHandle]
        ? ksBundles[bundleHandle]['new_price']
        : null;
      let bundlePriceInCents = Number($(element).attr('product-cents'));

      // Check for items that don't have any items. Meaning these are items
      // that are added just to display a discount.
      if (newPrice === null) {
        // Override discount if there is a sitewide sale going on.
        let bundleDiscount = ksBundles[bundleHandle]['discount'];
        if (saleSettings.sitewide.active && Number(saleSettings.key) > Number(bundleDiscount)) {
          bundleDiscount = saleSettings.key;
        }
        newPrice = formatPriceWithCurrencySymbol(
          subtractPercentage(bundlePriceInCents, bundleDiscount)
        );
      }
      FINAL_PRICE.innerText = newPrice;
      $(element).html(FINAL_PRICE);
      ORIGINAL_PRICE.classList.add('Price--compareAt');

      // Check if the bundle has a price of 0, meaning this bundle is being
      // used as a bundle reference. If so, use the combined price of the items
      // included in the bundle.
      if ($(element).attr('product-cents') === '0') {
        bundlePrice = ksBundles[bundleHandle].original_price;
      }
      ORIGINAL_PRICE.innerText = bundlePrice;
      $(element).append(ORIGINAL_PRICE);
    }
  }
}

const OBSERVER = new MutationObserver(function (mutationsList) {
  productAvailabilityChecker();
});

/**
 * ----------------------------------------------------------------------------
 * AJAX Observers
 * ----------------------------------------------------------------------------
 */
$(document).ready(function () {
  // Observe changes for product collections when using endless scroll for
  // products.
  // Reference: https://ajaxinate.elkfox.io/
  if ($('#AjaxinateContainer').length) {
    OBSERVER.observe(document.querySelector('#AjaxinateContainer'), {
      subtree: false,
      childList: true,
    });
  }

  // Observe changes after loading product recommendations. Product
  // recommendation are loaded after initial page load using Shopify's Product
  // Recommendations API.
  // Reference: https://shopify.dev/api/ajax/reference/product-recommendations
  if ($('.ProductRecommendations').length) {
    OBSERVER.observe(document.querySelector('.ProductRecommendations'), {
      subtree: false,
      childList: true,
    });
  }
});
